import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CareerChallengeAdminStore } from '../shared/career-challenge-admin.store';

@Component({
  selector: 'app-career-challenge-detail',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './career-challenge-detail.component.html',
  styleUrl: './career-challenge-detail.component.scss'
})
export class CareerChallengeDetailComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly store = inject(CareerChallengeAdminStore);

  get id(): string {
    return this.route.snapshot.paramMap.get('id') ?? '';
  }

  get showTabs(): boolean {
    return !!this.id && this.id !== 'new';
  }

  get hideContestTabs(): boolean {
    return this.store.challenge()?.access?.mode === 'first_sga_evaluation';
  }

  ngOnInit(): void {
    if (this.id && this.id !== 'new') {
      void this.store.load(this.id);
    }
  }

  tabLink(path: string): string[] {
    return ['/admin/career-challenges', this.id, path];
  }
}
